import type { SaturatedCondensateViscosityParameters } from "../../d";

export function saturatedCondensateViscosityCalculator(
  params: SaturatedCondensateViscosityParameters
): {
  a: number;
  b: number;
  saturatedCondensateViscosity: number;
} {
  const { solutionGasRso, deadCondensateViscosity } = params;
  // Q34: =10.715*(J12+100)**-0.515
  const a = 10.715 * (solutionGasRso + 100) ** -0.515;

  // Q36: =5.44*(J12+150)**-0.338
  const b = 5.44 * (solutionGasRso + 150) ** -0.338;

  // Q38: =Q34*Q17**Q36
  const saturatedCondensateViscosity = a * deadCondensateViscosity ** b;

  return {
    a,
    b,
    saturatedCondensateViscosity
  };
}
